// BuildingDetail.js
import React from 'react';
import { FiArrowLeft, FiPhone } from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';
import DashboardLayout from '../dashboard/layout';
import './style.css';

export default function BuildingDetail() {
  const navigate = useNavigate();
  const location = useLocation();
  const record = location.state?.record;



  return (
      <div className="main-content">
        <button className="back-btn" onClick={() => navigate(-1)}><FiArrowLeft /> Буцах</button>
        <h2 className="dashboard-title">{record.owner} - {record.unit}</h2>

        <div className="detail-section">
          <p><strong>Эзэмшигч:</strong> {record.owner}</p>
          <p><strong>Байр:</strong> {record.unit}</p>
          <p><strong>Оршин суугч:</strong> {record.occupants}</p>
          <p><strong>Утас:</strong> <FiPhone /> {record.phone}</p>
          <p><strong>Үлдэгдэл:</strong> {record.paymentDue?.toLocaleString()}₮</p>
        </div>

        <h3>Төлбөрийн түүх</h3>
        <table className="dashboard-table">
          <thead>
            <tr>
              <th>Сар</th>
              <th>Дүн</th>
            </tr>
          </thead>
          <tbody>
            {record.paymentHistory?.length === 0 ? (
              <tr><td colSpan={2}>Төлбөрийн түүх байхгүй</td></tr>
            ) : (
              record.paymentHistory.map((p, idx) => (
                <tr key={idx}>
                  <td>{p.month}</td>
                  <td>{p.amount.toLocaleString()}₮</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
  );
}
